import React, { useContext } from "react";
import { ListTablePaginated } from "./ListTablePaginated";
import { ArticulosContext } from "src/context/ArticulosContext";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { getArticulos, getArticulosPaginated } from "../helpers/ArticulosData"
import { Button, Fab, Grid, useMediaQuery, useTheme } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { ArticulosForm } from "./ArticulosForm";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import { saveData } from "src/general_helpers/manageData";
import { obtenerProcesosPorPerfilYMenu } from "src/general_components/functionEsArray";
/* Listado de Articulos */

export const ArticulosList = (props) => {

  const {
    setArticulosFormData,
    message,
    severity,
    snackbarVisible,
    setSnackbarVisible,
    setModelSave, setArticulo, modalState, setModalState
  } = useContext(ArticulosContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  let parametros_proyecto = JSON.parse(localStorage.getItem("parametros_proyecto"));
  const titulo_config = parametros_proyecto?.titulo_articulos;
  const titulo_proceso = titulo_config ? "Alta de " + titulo_config : "Alta de Articulos";

  const restricciones = obtenerProcesosPorPerfilYMenu();
  let alta = true;
  if (restricciones) {
    alta = restricciones.alta;
  }

  // Columnas del Listtable
  const columns = [
    { field: 'id', headerName: 'ID', flex: 0.1 },
    { field: 'nombre', headerName: 'Nombre', flex: 0.3 },
    { field: 'alias', headerName: 'Nombre reducido', flex: 0.3 },
  ];

  // Propiedades del Listtable
  const options = {
    cols: columns,
    get: getArticulos,
    getPaginated: getArticulosPaginated,
    limit: 50,
    server: false,
    pageSize: [50, 100, 150, 200],
    printButton: true
  }

  const dialogChild = <ArticulosForm />

  const toggleModal = () => {
    setModalState(!modalState)
    if (modalState) {
      setModelSave("")
      setArticulo("0")
    }
  }

  const handleAgregar = () => {
    setArticulosFormData({})
    toggleModal()
  }

  return (
    <>
      <Grid>
        {!isMobile && alta && (
          <Grid container marginTop={'10px'} justifyContent="flex-end">
            <Button
              variant="contained"
              size="small"
              onClick={handleAgregar}
            >
              <AddCircle />
              <div>Agregar</div>
            </Button>
          </Grid>
        )}
        <ListTablePaginated options={options} />
        <SimpleDialogComponent
          open={modalState}
          modalName={titulo_proceso}
          child={dialogChild}
          setPushData={saveData}
          handleClose={toggleModal}
          buttonEnviar={false}
          buttonCancelar={true}
        />
        <SnackbarMessenger
          open={snackbarVisible}
          message={message}
          severity={severity}
          close={() => { setSnackbarVisible(false) }} />
      </Grid>
      {isMobile && alta && (
        <div style={{ position: 'fixed', bottom: 56, right: 20, zIndex: 9999 }}>
          <Fab color="primary" onClick={handleAgregar}>
            <AddIcon />
          </Fab>
        </div>
      )}
    </>
  );
};
